export const datePickerPopperModifiers = {
    flip: {
        behavior: ["bottom"], // don't allow it to flip to be above
    },
    preventOverflow: {
        enabled: false, // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
    },
    hide: {
        enabled: false, // turn off since needs preventOverflow to be enabled
    },
}